// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export const ExtensionsPage = lazyView(() =>
  import("./ui/ExtensionsPage.js").then((m) => m.ExtensionsPage),
);
